import React, { useState, Suspense } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';
import Button from '../../common/Button';
import styles from './style.module.scss';

const BuilderModal = React.lazy(() => import(/* webpackChunkName: "builder-modal" */ '../../builder-common/BuilderModal'));

const BundleProductFeatures = (props) => {
  const { product, inList } = props;
  const { short_description: shortDescription = {} } = product;
  const {
    html: descriptionHtml = ''
  } = shortDescription;
  const [showFeatures, setShowFeatures] = useState(false);

  const productDescriptionMarkup = (html) => {
    return {__html: html};
  };

  return (
    <div className={inList ? styles.productFeaturesList : styles.productFeatures}>
      {(descriptionHtml && descriptionHtml.trim() !== '') && (
        <>
          <Button
            label="information"
            trigger={() => { setShowFeatures(true); }}
            iconType="information"
            buttonStyle="Information"
            showLabel={false}
          />
          <Suspense fallback={<div>Loading...</div>}>
            <BuilderModal
              isOpen={showFeatures}
              exitModal={() => setShowFeatures(false)}
            >
              <h4>Features</h4>
              <div
                className={styles.productFeaturesInner}
                dangerouslySetInnerHTML={productDescriptionMarkup(descriptionHtml)}
              />
            </BuilderModal>
          </Suspense>
        </>
      )}
    </div>
  );
};

BundleProductFeatures.propTypes = {
  product: PropTypes.shape({}),
  inList: PropTypes.bool,
};

BundleProductFeatures.defaultProps = {
  product: {},
  inList: false,
};

export default BundleProductFeatures;
